import { CrudServiceBase } from '@utils';
import { ParkAreaAssesmentAnswer } from './park-area-assesment-answer.class';

export class ParkAreaAssesmentAnswerService extends CrudServiceBase<ParkAreaAssesmentAnswer> {
	constructor(parkAreaAssesmentId: string) {
		super(ParkAreaAssesmentAnswer, `park-area-assesment/${parkAreaAssesmentId}/park-area-assesment-answer`);
	}
}
